/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import JsController from '../../js-controller';
import { isSameDayOfWeek } from '../../../../framework/scripts/utils/time';

export default (app: App) => {
	const controller = new JsController(app, 'half image banner');
	controller.addMountFunction(() => {
		mountComponent();
	});

	return controller.init();
};

export function mountComponent() {
	const halfImageBanners = document.querySelectorAll<HTMLElement>('.half-image-banner');

	function getCurrentDate() {
		const currentDay = new Date();
		const month = String(currentDay).split(' ')[1];
		const day = String(currentDay).split(' ')[2];
		return `${month} ${day}`;
	}

	for (const halfImageBanner of halfImageBanners) {
		const openingTimes = halfImageBanner.querySelectorAll<HTMLElement>('.opening-time');
		if (openingTimes) {
			for (const [index, openingTime] of openingTimes.entries()) {
				const openingTimeDay = openingTime.querySelector<HTMLElement>('.opening-time-day');
				const currentDayNumber = new Date().getDay();

				if (openingTimeDay && index === currentDayNumber - 1) {
					const currentDay = getCurrentDate();
					const day = openingTimeDay.textContent;
					openingTime.classList.add('text-primary-accent-text');
					openingTimeDay.classList.add('font-semibold');
					openingTimeDay.textContent = `${day} ${currentDay}`;
				}
			}
		}

		// Get Datalocation
		const openingHoursContainer = halfImageBanner.querySelector<HTMLElement>('.opening-time-wrapper');
		const storeTimezone = openingHoursContainer?.getAttribute('data-timezone');
		const date = new Date();
		const storeLocalDate = new Date(date.toLocaleString('en-US', { timeZone: storeTimezone! }));

		const hours = storeLocalDate.getHours();
		const minutes = storeLocalDate.getMinutes();

		// Pill
		const openingTimeData = halfImageBanner.querySelectorAll<HTMLElement>('.opening-time-data');
		const openPill = halfImageBanner.querySelector<HTMLElement>('.open-status-pill.open');
		const closedPill = halfImageBanner.querySelector<HTMLElement>('.open-status-pill.closed');
		const closingSoonPill = halfImageBanner.querySelector<HTMLElement>('.open-status-pill.closing-soon');
		if (openingTimeData) {
			let storeStatus = 'closed';
			openingTimeData.forEach((timeData) => {
				const openingTimeDay = timeData.querySelector<HTMLElement>('.opening-time-day');
				openPill?.classList.add('hidden');
				closingSoonPill?.classList.add('hidden');
				closedPill?.classList.add('hidden');
				if (openingTimeDay && openingTimeDay.textContent) {
					if (isSameDayOfWeek(openingTimeDay?.textContent)) {
						const openingTimeRange = timeData.querySelector<HTMLElement>('.opening-time-range');
						const openingTime = openingTimeRange?.textContent?.split(' - ')[0];
						const closingTime = openingTimeRange?.textContent?.split(' - ')[1];
						if (openingTime && closingTime) {
							storeStatus = checkTimeInRange(
								hours * 100 + minutes,
								parseInt(convertTo24Hour(openingTime)),
								parseInt(convertTo24Hour(closingTime))
							);
						}
					}
				}
			});

			if (storeStatus === 'open') {
				openPill?.classList.remove('hidden');
			} else if (storeStatus === 'closing-soon') {
				closingSoonPill?.classList.remove('hidden');
			} else {
				closedPill?.classList.remove('hidden');
			}
		}

		function convertTo24Hour(time: string) {
			if (time.length < 7) {
				time = '0' + time;
			}
			let hours = parseInt(time.substring(0, 2));
			if (hours === 12 && time.toLowerCase().includes('am')) hours = 0o0;
			const minutes = parseInt(time.substring(3, 5));
			const pm = time.toLowerCase().includes('pm');
			return `${pm ? hours + 12 : hours}${minutes === 0 ? '00' : minutes}`;
		}

		function checkTimeInRange(currentTime: number, openTime: number, closeTime: number) {
			if (currentTime >= closeTime - 100 && currentTime <= closeTime) {
				return 'closing-soon';
			} else if (currentTime >= openTime && currentTime <= closeTime) {
				return 'open';
			} else {
				return 'closed';
			}
		}
	}
}
